import { useCallback } from 'react';

import { useToastStore } from 'dibs-toaster/exports/useToastStore.ts';
import { ACTION_RESULT_TOAST_PROPS } from 'dibs-toaster/exports/sharedToastProps.ts';

import {
    AddToFavoritesToastContent,
    RemoveFromFavoritesToastContent,
} from './FavoritesToastsContent.tsx';
import { trackItemFavoritingToast } from './tracking.ts';
import { ADD_TO_FAVORITES_ACTION } from './constants.ts';

const useFavoritesToasts = (): {
    addToFavoritesToast: () => void;
    removeFromFavoritesToast: () => void;
} => {
    const addToast = useToastStore(state => state.add);

    const addToFavoritesToast = useCallback(() => {
        addToast({
            toast: {
                ...ACTION_RESULT_TOAST_PROPS,
                children: <AddToFavoritesToastContent />,
            },
            toastAction: ADD_TO_FAVORITES_ACTION,
        });
        trackItemFavoritingToast({ trigger: 'favorited' });
    }, [addToast]);

    const removeFromFavoritesToast = useCallback(() => {
        addToast({
            toast: {
                ...ACTION_RESULT_TOAST_PROPS,
                children: <RemoveFromFavoritesToastContent />,
            },
        });
        trackItemFavoritingToast({ trigger: 'favorite removed' });
    }, [addToast]);

    return {
        addToFavoritesToast,
        removeFromFavoritesToast,
    };
};

export { useFavoritesToasts };
